<template>
  <b-container class="py-4">
    <b-row align-h="center">
      <b-col lg="12" class="col-xl-8">
        <h1 class="mb-3">Organization data</h1>
        <b-card>
          <b-form-group label-cols-lg="2" label="Name">
            <h3>{{ organization.name }}</h3>
          </b-form-group>
          <b-form-group label-cols-lg="2" label="Logo">
            <div class="mb-3 d-flex justify-content-center">
              <div style="width:300px">
                <LogoImage
                  ref="logo_image"
                  :options="logoImageOptions"
                  v-on:completedEvent="completedEvent"
                  v-on:errorEvent="errorEvent"
                ></LogoImage>
              </div>
            </div>
          </b-form-group>
          <b-form-group label-cols-lg="2" label="Type">
            <b-input v-model="organization.type" />
          </b-form-group>
          <b-form-group label-cols-lg="2" label="Description">
            <b-textarea rows="4" max-rows="10" v-model="organization.about"></b-textarea>
          </b-form-group>
          <b-form-group
            label-cols-lg="2"
            label="Reg No."
            :state="regNumberState"
            invalid-feedback="This field is requred"
          >
            <b-input v-model="organization.reg_number" required />
          </b-form-group>
          <b-form-group
            label-cols-lg="2"
            label="Phone"
            :state="phoneState"
            invalid-feedback="This field is requred"
          >
            <b-input v-model="organization.phone" required />
          </b-form-group>
          <b-form-group
            label-cols-lg="2"
            label="E-mail"
            :state="emailState"
            invalid-feedback="This field is requred"
          >
            <b-input v-model="organization.email" />
          </b-form-group>
          <b-form-group label-cols-lg="2" label="Website">
            <b-input v-model="organization.website" />
          </b-form-group>
          <b-form-group label-cols-lg="2" label="Address">
            <b-input v-model="organization.address" />
          </b-form-group>
          <b-form-group label-cols-lg="2" label="City">
            <b-input v-model="organization.city" />
          </b-form-group>
          <b-form-group label-cols-lg="2">
            <div class="d-flex">
              <b-button variant="success" class="mr-auto" @click.prevent="updateData">
                <i class="fas fa-check"></i>
                Save
              </b-button>
              <b-button variant="outline-secondary" :to="{name:'home'}">Cancel</b-button>
            </div>
          </b-form-group>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import config from "@/config";
import { mapGetters, mapActions, mapMutations } from "vuex";
import LogoImage from "@/components/LogoImage";
export default {
  components: {
    LogoImage
  },
  data() {
    return {
      emailState: null,
      regNumberState: null,
      phoneState: null
    };
  },
  created() {
    this.getMyOrg()
      .then(() => {
        this.$refs.logo_image.addImage({
          src: this.organization.logo,
          progress: 100,
          completed: true
        });
      })
      .catch(err => {
        console.log(err);
        this.makeToast(
          "danger",
          "Greška",
          "Server error"
        );
      });
  },
  computed: {
    ...mapGetters({
      token: "auth/token",
      organization: "organization/orgData"
    }),
    logoImageOptions() {
      return {
        url: config.API_URL + "/ogranization/logo",
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
    }
  },
  methods: {
    ...mapActions({
      getMyOrg: "organization/getMyOrg",
      updateMyOrg: "organization/updateMyOrg"
    }),
    ...mapMutations({
      setLogo: "organization/SET_LOGO"
    }),
    validateForm() {
      this.regNumberState = this.organization.reg_number.length > 0;
      this.emailState = this.organization.email.length > 0;
      this.phoneState = this.organization.phone.length > 0;
      this.errorState = !(
        this.regNumberState &&
        this.emailState &&
        this.phoneState
      );
    },
    sendingEvent(file, xhr, formData) {},
    completedEvent(file, response) {
      this.setLogo(response);
      this.makeToast(
        "success",
        "New logo",
        "Logo has been updated."
      );
    },
    errorEvent(file, response) {
      this.$refs.logo_image.addImage({
        src: this.organization.logo,
        progress: 100,
        completed: true
      });
      this.makeToast("danger", "Error", "Error while sending the request.");
    },
    updateData() {
      this.validateForm();
      if (this.errorState) {
        return null;
      }
      this.updateMyOrg()
        .then(() => {
          this.makeToast("success", "Saved", "Updates are saved.");
        })
        .catch(err => {
          this.makeToast(
            "danger",
            "Error",
            "Server error"
          );
        });
    }
  }
};
</script>

<style>
</style>